export enum FeatureToggle {
  catalogAdmin = 'catalogAdmin',
  ShowQasWorkflowActions = 'rt_catalog_admin_show_qas_workflow_actions',
  ShowCampPipelineEditor = 'rt_catalog_admin_show_camp_pipeline_editor',
  ShowCampAsyncStepPreview = 'rt_catalog_admin_show_camp_async_step_preview',
  PriceAnomalyAmsApproval = 'rt_price_anomaly_patch_ams_approval',
  SourcePriorityManagementTool = 'rt_source_priority_management_tool_admin',
  // Gates the Structured Input step type, the Structured Decorator step type, and
  // the Decorator tab/category. See STRUCTURED_INPUT_GATED_TYPES /
  // STRUCTURED_INPUT_GATED_CATEGORIES for the gated surfaces.
  ShowStructuredInput = 'rt_catalog_admin_show_structured_input',
  // Gates the Attribute Sentinel managed-attribute panel + prompt-source control
  // in the LLM prompt template step form. Configure per environment in Roulette:
  // on in dev/staging, allow-list in production to test without affecting others.
  ShowSentinelManagedAttributes = 'rt_catalog_admin_show_sentinel_managed_attributes',
}
